import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { SubscriptionService } from '../features/subscription/services/subscription.service';
import { map, catchError, of, switchMap } from 'rxjs';
import { SubscriptionStatus } from '@gqlSchema';

export const subscriptionGuard = () => {
  const subscriptionService = inject(SubscriptionService);
  const router = inject(Router);

  const activeStatuses: SubscriptionStatus[] = [
    SubscriptionStatus.Active,
    SubscriptionStatus.Trialing,
    SubscriptionStatus.PastDue,
    SubscriptionStatus.Manual,
    SubscriptionStatus.Canceled,
  ];

  return subscriptionService.getMySubscription().pipe(
    switchMap((sub) => {
      if (sub && activeStatuses.includes(sub.status)) {
        return of(true);
      }

      // No active subscription — check if Stripe is enabled
      return subscriptionService.getInstanceConfig().pipe(
        map((config) => {
          const stripeEnabled = config?.stripeEnabled ?? false;
          if (stripeEnabled) {
            // Stripe enabled: redirect to pricing page to subscribe
            return router.createUrlTree(['/pricing']);
          }
          // Stripe disabled: let through — wrapper blocked overlay handles this
          return true;
        }),
      );
    }),
    catchError(() => of(true)),
  );
};
